import { render, staticRenderFns } from "./PermissionFormModal.vue?vue&type=template&id=ff0b8464&scoped=true&"
import script from "./PermissionFormModal.vue?vue&type=script&lang=js&"
export * from "./PermissionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b8464",
  null
  
)

export default component.exports